// 首页CID
export const HomePageCid = 'c_waimai_c_overseas_aatucy3n';
//
export const ProductCardMv = 'b_waimai_c_overseas_vb9w5duu_mv';
//
export const ProductCardMc = 'b_waimai_c_overseas_vb9w5duu_mc';
